import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	company: {
		id: 'footer.company',
		defaultMessage: 'Company',
		description: 'Footer Company Link',
	},
	about: {
		id: 'footer.about',
		defaultMessage: 'About',
		description: 'Footer About Link',
	},
	careers: {
		id: 'footer.careers',
		defaultMessage: 'Careers',
		description: 'Footer Careers Link',
	},
	press: {
		id: 'footer.press',
		defaultMessage: 'Press',
		description: 'Footer Press Link',
	},
	blog: {
		id: 'footer.blog',
		defaultMessage: 'Blog',
		description: 'Footer Blog Link',
	},
	instructor: {
		id: 'footer.instructor',
		defaultMessage: 'Meet our Instructor',
		description: 'Footer Instructor Link',
	},
	science: {
		id: 'footer.science',
		defaultMessage: 'Calm Science',
		description: 'Footer Science Link',
	},
	partnerships: {
		id: 'footer.partnerships',
		defaultMessage: 'Brand Partnerships',
		description: 'Footer Partnerships Link',
	},
	offers: {
		id: 'footer.offers',
		defaultMessage: 'Offers',
		description: 'Footer Offers Link',
	},
	gift: {
		id: 'footer.gift',
		defaultMessage: 'Buy a Gift',
		description: 'Footer Buy Gift Link',
	},
	redeem: {
		id: 'footer.redeem',
		defaultMessage: 'Redeem a Gift',
		description: 'Footer Redeem Gift Link',
	},
	familyPlan: {
		id: 'footer.familyPlan',
		defaultMessage: 'Family Plan',
		description: 'Footer Family Plan Link',
	},
	calmStudents: {
		id: 'footer.calmStudents',
		defaultMessage: 'Calm for Students',
		description: 'Footer Students Link',
	},
	help: {
		id: 'footer.help',
		defaultMessage: 'Help',
		description: 'Footer Help Link',
	},
	faq: {
		id: 'footer.faq',
		defaultMessage: 'FAQ',
		description: 'Footer FAQ Link',
	},
	contact: {
		id: 'footer.contact',
		defaultMessage: 'Contact Us',
		description: 'Footer Contact Us Link',
	},
	terms: {
		id: 'footer.terms',
		defaultMessage: 'Terms',
		description: 'Footer Terms Link',
	},
	privacy: {
		id: 'footer.privacyPolicy',
		defaultMessage: 'Privacy Policy',
		description: 'Footer Privacy Link',
	},
	calmConsumerHealthDataPrivacyPolicy: {
		id: 'footer.calmConsumerHealthDataPrivacyPolicy',
		defaultMessage: 'Consumer Health Data',
		description: 'Footer Calm Consumer Health Data Privacy Policy Link',
	},
	californiaPrivacyNotice: {
		id: 'footer.californiaPrivacyNotice',
		defaultMessage: 'CCPA Notice',
		description: 'Footer California Privacy Notice Link',
	},
	accessibilityStatement: {
		id: 'footer.accessibilityStatement',
		defaultMessage: 'Accessibility Statement',
		description: 'Footer Accessibility Statement Link',
	},
	patents: {
		id: 'footer.patents',
		defaultMessage: 'Virtual Patent Marking',
		description: 'Footer Patents Link',
	},
	optOut: {
		id: 'footer.optOut',
		defaultMessage: 'Opt Out of Targeted Ads',
		description: 'Footer Opt Out of Targeted Ads Link',
	},
	privacyChoices: {
		id: 'footer.privacyChoices',
		defaultMessage: 'Your Privacy Choices',
		description: 'Footer Privacy Choices Link',
	},
	cookies: {
		id: 'footer.cookies',
		defaultMessage: 'Cookies',
		description: 'Footer Cookies Link',
	},
	copyright: {
		id: 'footer.copyright',
		defaultMessage: 'Copyright © {year} Calm. All rights reserved',
		description: 'Footer copyright with dynamic year',
	},
	socialIconAriaLabel: {
		id: 'footer.socialIconAriaLabel',
		defaultMessage: "Link to Calm's {socialMedia}",
		description: 'A screen reader only label for social media links',
	},
	calmForOrganizations: {
		id: 'footer.calmForOrganizations',
		defaultMessage: 'Calm for Organizations',
		description: 'Footer Calm for Organizations Link',
	},
	calmForOrganizationsUnder300: {
		id: 'footer.calmForOrganizationsUnder300',
		defaultMessage: 'Organizations under 300',
		description: 'Footer Calm for organizations under 300 Link',
	},
	calmForOrganizationsOver300: {
		id: 'footer.calmForOrganizationsOver300',
		defaultMessage: 'Organizations 300+',
		description: 'Footer Calm for organizations over 300 Link',
	},
});
